import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';
import classNames from 'classnames';

import AllRightsReserved from '../AllRightsReserved';

import './router.scss';
import { connect } from 'react-redux';

const PublicRoute = ({ userInfo, component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        const { pathname } = props.location;
        const classes = classNames('route-wrapper', {
          'full-background': ['/login', 'forgot-password'].includes(pathname),
        });
        return (
          <Fragment>
            <div className={classes}>
              <Component {...props} />
              <AllRightsReserved />
            </div>
          </Fragment>
        );
      }}
    />
  );
};

const mapStateToProps = (state) => ({
  userInfo: state.auth.userInfo.info,
});

export default connect(mapStateToProps)(PublicRoute);
